import React from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";
import { FileMetadata } from "../../../../generated/file-api";
import ProfilePicture from "../../../ProfilePicture/ProfilePicture";
import { calculateTimeSinceDate } from "../../../../Utils/Meeting";
import Tooltip from "../../../Tooltip/Tooltip";
import { useStyles } from "./FileList.style";
import FileActionButton from "../../../Buttons/FileActionButton/FileActionButton";
import { fileService } from "../../../../Providers/ServiceProvider/ServiceProvider";
import { useCustomerId } from "../../../../Providers/CustomerProvider/CustomerProvider";
import { messages } from "./FileList.messages";

interface Props {
  files: FileMetadata[];
  onDownloaded?: () => void;
  onDeleted?: () => void;
}

const FileList = (props: Props) => {
  const { files, onDownloaded, onDeleted } = props;
  const intl = useIntl();
  const classes = useStyles();
  const customerId = useCustomerId();
  const { enqueueSnackbar } = useSnackbar();

  const openInNewTab = (file: FileMetadata) => {
    // Trigger window.open() outside async method to be able to make it work for safari on iphone
    let windowRef: Window | null = null;
    windowRef = window.open();

    if (customerId) {
      fileService()
        .downloadFileRaw({
          customerId,
          fileId: file.fileId,
        })
        .then((res) => Promise.resolve(res.raw.blob()))
        .then((blob) => {
          if (windowRef !== null) {
            // @ts-ignore
            windowRef.location = URL.createObjectURL(blob);
          }
        })
        .catch(() =>
          enqueueSnackbar(intl.formatMessage(messages.error), {
            variant: "error",
          })
        );
    }
  };

  const mapFiles = files.map((file) => {
    return (
      <Tooltip title={file.fileName}>
        <ListItem
          button
          onClick={() => openInNewTab(file)}
          className={classes.listItem}
        >
          <ListItemAvatar>
            <ProfilePicture
              firstName={file.uploadedBy.firstName}
              lastName={file.uploadedBy.lastName}
            />
          </ListItemAvatar>
          <ListItemText
            primary={file.fileName}
            secondary={calculateTimeSinceDate(
              file.uploadedOn || new Date(),
              intl.locale
            )}
            primaryTypographyProps={{
              variant: "body2",
              noWrap: true,
              style: { paddingRight: 40 },
            }}
          />
          <ListItemSecondaryAction>
            <FileActionButton
              fileId={file.fileId}
              fileName={file.fileName}
              uploadedBy={file.uploadedBy.id}
              onDownloaded={onDownloaded}
              onDeleted={onDeleted}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </Tooltip>
    );
  });

  return <List>{mapFiles}</List>;
};

export default FileList;
